export default __webpack_public_path__ + "static/media/img10.d254aaea.png";